/**
 * Generates a function that will fire a specified callback function when it detects that the app has crashed.
 *
 * @method getCrashDetectionFunction
 * @param {Function} callback - function to call when the function detects that the app has crashed
 * @returns {Function} a function to call that will perform a crash detection
 */
const getCrashDetectionFunction = (callback) => {
  let badStateDetectionCount = 0;
  let logoExistedOnce = false;

  const isGood = () => {
    const logoExists = Boolean(document.querySelector('img[src$="logo.svg"]'));
    const anyLoadingIndicatorExists = Boolean(
      document.querySelector('.LoadingIndicatorForApp') ||
        document.querySelector('.LoadingIndicatorForDocument'),
    );
    const statusPageExists = Boolean(document.querySelector('.status-page'));
    const isOffline = !navigator.onLine; // Don't consider offline as a crash

    // Don't trigger crash detection when offline, as network issues can cause UI changes
    // We also check if the status page is already showing to avoid redundant triggers
    if (isOffline || statusPageExists) {
      return true;
    }

    if (logoExists) {
      logoExistedOnce = true;
    } else {
      // The logo existed once, but not anymore, and we aren't loading anything.
      if (logoExistedOnce || !anyLoadingIndicatorExists) {
        return false;
      }
    }

    return true;
  };

  return () => {
    const wasGood = isGood();

    // Bad state.
    if (!wasGood) {
      // Require an arbitrary number of bad states in a row to consider the app crashed.
      // Timing-wise, this is a multiplier on CRASH_DETECTION_INTERVAL
      if (badStateDetectionCount < 3) {
        badStateDetectionCount += 1;

        return;
      }

      return callback();
    }

    // Good state. Reset the count.
    if (wasGood) {
      badStateDetectionCount = 0;
    }
  };
};

export default getCrashDetectionFunction;
